export default __webpack_public_path__ + "static/media/buyer-activity.793b4460.svg";